export default __webpack_public_path__ + "static/assets/df5bd4d969049e234c8fc2382b89b7b5.png";